import React from 'react';
import { Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import * as Icons from '@ant-design/icons';

import { graphql, withApollo } from 'react-apollo';

import Loading from '../../../common/Loading';

import FormTalonario from './FormTalonario';

import getTalonarios from '../../../../graphql/querys/otros/getTalonarios.graphql';
import insertTalonario from '../../../../graphql/mutations/otros/insertTalonario.graphql';
import { errorService } from '../../../../graphql/utils/utils';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@graphql(insertTalonario, {
  name: 'insertTalonario',
  options: {
    refetchQueries: [{ query: getTalonarios }],
  },
})
class CrearTalonario extends React.Component {
  constructor(props) {
    super(props);

    // console.log("Entre al constructor");

    this.state = {
      talonario: {
        codigo: '',
        nombre: '',
        cantidad: 0,
      },
      step: 0,
      loading: false,
    };

    this.guardarTalonario = this.guardarTalonario.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  guardarTalonario(talonario) {
    this.props
      .insertTalonario({
        variables: {
          talonario,
        },
      })
      // eslint-disable-next-line no-unused-vars
      .then(res => {
        notification.success({
          message: 'Creacion Correcta',
          description: 'Se ha registrado el nuevo talonario exitosamente',
        });

        this.props.history.push('/admin/otros/talonarios');
      })
      .catch(err => {
        console.log('Error en la creacion del talonario');
        console.log(err);
        errorService(err, {
          talonario,
        });

        Modal.error({
          title: 'Error en la inicializacion del componente grafico',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  }

  onCancel() {
    this.setState({
      fase: 0,
    });
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Talonario</Breadcrumb.Item>
          <Breadcrumb.Item>Crear</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Crear Talonario
          </h2>
          <br />
          <div style={estiloContent}>
            <FormTalonario
              className="formularios"
              onSubmit={this.guardarTalonario}
              onAnterior={() =>
                this.props.history.push('/admin/otros/talonarios')
              }
              datos={this.state.talonario}
            />
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(CrearTalonario);
